import React from "react";

export default function VehicleDeliveryGift({ data, loading, children }) {
  return <div>{children}</div>;
}
